import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { trackFreeTierCTAClick } from '../../topPanels/utils';
import { getUserData } from '../../selectors/user';
import { calculateFreeTierInstalls, isAboutToMaxCap, showFreeTierCap } from '../utils';
import { HEADERS } from '../consts';
import css from '../style.css';

function FreeTierChip() {
    const userData = useSelector(getUserData) || {};

    if (!userData.email || !showFreeTierCap(userData)) {
        return null;
    }

    const onUpgradeClick = () => {
        trackFreeTierCTAClick(userData.email, userData.first_name, userData.last_name, userData.company);
        window.location.href = '#/react/account-plan#upgrade-plan';
    };

    return (
        <div className={classNames(css.planChip, css.hideBelowXl)}>
            <span className={classNames({ [css.planCountAlert]: isAboutToMaxCap(userData) })}>
                {calculateFreeTierInstalls(userData)}
            </span>
            <Translate id={`${HEADERS}.FREE_TIER_CAP_TEXT`} />
            <button type="button" className={css.menuToggle} onClick={onUpgradeClick}>
                <Translate id={`${HEADERS}.UPGRADE_USER_PLAN_BUTTON`} />
            </button>
        </div>
    );
}

export default FreeTierChip;
